/**
 * 再資源化
 * 再資源化処理フロー
 */
import Vue from "vue";
import * as httpConst from "../../../../constants/httpConst";

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/recycle_disposal_flows`;

const master_recycle_disposal_flow = {
  namespaced: true,
  state: () => {},
  getters: {},
  actions: {
    index ({ commit }, { condition, page, limit, format }) {
      let api_path

      if (format === 'csv') {
        api_path = `${API_PATH}.csv`
      } else {
        api_path = API_PATH
      }

      const params = {
        ...condition,
        page: page,
        limit: limit,
      }

      return new Promise((resolve) => {
        Vue.$http.get(api_path, { params: params }).then((data) => {
          if (format !== 'csv') {
            let content = data.content
            resolve(content)
          } else {
            resolve(data)
          }
        })
      })
    },
    new () {
      return new Promise((resolve) => {
        Vue.$http.get(`${API_PATH}/new`).then(data => {
          let content = data.content
          resolve(content)
        })
      });
    },
    edit ({ commit }, { id }) {
      return new Promise((resolve) => {
        Vue.$http.get(`${API_PATH}/${id}/edit`).then(data => {
          let content = data.content
          resolve(content)
        })
      });
    },
    create ({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        const content = {};
        Vue.$http.post(API_PATH, params ).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },

    update ({ commit }, { id, params }) {
      return new Promise( ( resolve ) => {
        const content = {};
        Vue.$http.put(`${API_PATH}/${id}`, params ).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '更新しました' }, { root: true })
          resolve(content)
        } )
      })
    },

    destroy ({ commit }, { id }) {
      return new Promise( ( resolve ) => {
        Vue.$http.delete(`${API_PATH}/${id}`).then(data => {
          let content = data.content;
          commit('snackbar/showInfo', { message: '削除しました' }, { root: true })
          resolve(content)
        })
      })
    },
  },
  mutations: {},
};

export default master_recycle_disposal_flow;
